/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoutes = ({ component: Component, isAuth, ...props }) => {
  const { mfa } = useSelector((store) => store.auth);
  const redirectTo = mfa?.required ? '/mfa' : '/login';

  return (
    <Route
      {...props}
      render={(props) => 
        (isAuth ? <Component {...props} isAuth={isAuth} /> : <Redirect to={redirectTo} />)
      }
    />
  );
};

PrivateRoutes.propTypes = {
  isAuth: PropTypes.bool.isRequired,
};

export default PrivateRoutes;
